import Rest from '../Rest'

export default class CancellationMovementService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/cancellation_movements'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  process(ids: number[]) {
    return this.post('/process', { ids })
  }
}
